const document = [
  {
    key: "state_change_logic",
    content: "State Change logic",
    html: `<div>
            <h3>State Change logic</h3>
        </div>`
  },
  {
    key: "post_job",
    content: "Add a post activity job",
    html: ``
  },
  {
    key: "next_activity_logic",
    content: "Next activity change logic",
    html: `<div>Next activity change logic</div>`
  },
  {
    key: "custom_css",
    content: `It should be in JSON format 
  Example-
  {
  "marginBottom" : "8px",
  "color": "#10182b"
  }`,

    html: `<div style={{display:"flex",flexDirection:"column",userSelect:"text"}}>
    <div>
    <pre>
  {
  "backgroundColor" : "#eee",
  "padding": "8px",
  "color": "#10182b",
  "borderRadius" : "4px",
  "border" : "1px solid #ccc",
  }
    </pre>
    <pre>
  {
  "backgroundColor" : "linear-gradient(91deg, #006ED9 0.17%, #1349C0 99.89%);",
  "padding": "16px",
  "borderRadius" : "12px",
  "fontSize": "24px"
  }
    </pre>
  `
  },
  {
    key: "remove_org_user",
    content: `It wil remove user from organisation access`,
    html: `<div>It wil remove user from organisation access</div>`
  },
  {
    key: "select_color_master_data",
    content: `Preview`,
    html: `<pre>{
    "value": "State Name",
    "operator": "",
    "color": "",
    "text": "",
    "number": 0,
    "range": null,
    "list": null,
    "styles": {
      "background": "#ECFDF3",
      "color": "#12B76A"
      "border": "1px solid #E7E4E7",
      "borderRadius": "2px"
    }</pre>`
  },
  {
    key: "choose_type_info",
    content: "Prefill for job mapping ",
    html: "<div>Prefill for job mapping.</div>"
  },

  //variable Keys
  {
    key: "URL_SHORTNER_API",
    content: "API endpoint for URL shortening services.",
    html: "<div>API endpoint for URL shortening services.</div>"
  },
  {
    key: "PAYMENT_GATEWAY",
    content: "Defines the payment gateway provider.",
    html: "<div>Defines the payment gateway provider.</div>"
  },
  {
    key: "MSG91_SUBDOMAIN",
    content: "Subdomain for MSG91 API and dashboard access.",
    html: "<div>Subdomain for MSG91 API and dashboard access.</div>"
  },
  {
    key: "MSG91_ACC_SID",
    content: "Account SID for MSG91 services.",
    html: "<div>Account SID for MSG91 services.</div>"
  },
  {
    key: "KALEYRA_API_URL",
    content: "API URL for Kaleyra SMS services.",
    html: "<div>API URL for Kaleyra SMS services.</div>"
  },
  {
    key: "KALEYRA_API_TOKEN",
    content: "API token for Kaleyra authentication.",
    html: "<div>API token for Kaleyra authentication.</div>"
  },
  {
    key: "KALEYRA_SUBDOMAIN",
    content: "Subdomain for Kaleyra API services.",
    html: "<div>Subdomain for Kaleyra API services.</div>"
  },
  {
    key: "KALEYRA_ACC_SID",
    content: "Account SID for Kaleyra API services.",
    html: "<div>Account SID for Kaleyra API services.</div>"
  },
  {
    key: "EXOTEL_API_URL",
    content: "API URL for Exotel SMS services.",
    html: "<div>API URL for Exotel SMS services.</div>"
  },
  {
    key: "EXOTEL_API_TOKEN",
    content: "API token for Exotel authentication.",
    html: "<div>API token for Exotel authentication.</div>"
  },
  {
    key: "EXOTEL_SUBDOMAIN",
    content: "Subdomain for Exotel services.",
    html: "<div>Subdomain for Exotel services.</div>"
  },
  {
    key: "EXOTEL_ACC_SID",
    content: "Account SID for Exotel authentication.",
    html: "<div>Account SID for Exotel authentication.</div>"
  },
  {
    key: "RAZORPAY_API_KEY",
    content: "API key for Razorpay payment gateway.",
    html: "<div>API key for Razorpay payment gateway.</div>"
  },
  {
    key: "RAZORPAY_CLIENT_SECRET",
    content: "Client secret for Razorpay authentication.",
    html: "<div>Client secret for Razorpay authentication.</div>"
  },
  {
    key: "TELEGRAM_KEY",
    content: "API key for Telegram bot integration.",
    html: "<div>API key for Telegram bot integration.</div>"
  },
  {
    key: "SMS_PROVIDER",
    content: "Defines the SMS service provider.",
    html: "<div>Defines the SMS service provider.</div>"
  },
  {
    key: "EMAIL_PROVIDER",
    content: "Defines the email service provider.",
    html: "<div>Defines the email service provider.</div>"
  },
  {
    key: "ENABLE_EMAIL_INCOMING",
    content: "Enables or disables incoming email processing.",
    html: "<div>Enables or disables incoming email processing.</div>"
  },
  {
    key: "MSG91_API_KEY",
    content: "API key for MSG91 SMS services.",
    html: "<div>API key for MSG91 SMS services.</div>"
  },
  {
    key: "MSG91_SENDER_ID",
    content: "Sender ID for MSG91 SMS services.",
    html: "<div>Sender ID for MSG91 SMS services.</div>"
  },
  {
    key: "MSG91_API_URL",
    content: "API URL for MSG91 services.",
    html: "<div>API URL for MSG91 services.</div>"
  },
  {
    key: "MSG91_API_TOKEN",
    content: "API token for MSG91 authentication.",
    html: "<div>API token for MSG91 authentication.</div>"
  },
  {
    key: "KALEYRA_API_KEY",
    content: "API key for Kaleyra SMS services.",
    html: "<div>API key for Kaleyra SMS services.</div>"
  },
  {
    key: "KALEYRA_SENDER_ID",
    content: "Sender ID for Kaleyra SMS services.",
    html: "<div>Sender ID for Kaleyra SMS services.</div>"
  },
  {
    key: "EXOTEL_API_KEY",
    content: "API key for Exotel SMS services.",
    html: "<div>API key for Exotel SMS services.</div>"
  },
  {
    key: "EXOTEL_SENDER_ID",
    content: "Sender ID for Exotel SMS services.",
    html: "<div>Sender ID for Exotel SMS services.</div>"
  },
  {
    key: "RDBMS_MYSQL_HOST",
    content: "Hostname for MySQL database.",
    html: "<div>Hostname for MySQL database.</div>"
  },
  {
    key: "RDBMS_MYSQL_PORT",
    content: "Port number for MySQL database.",
    html: "<div>Port number for MySQL database.</div>"
  },
  {
    key: "RDBMS_MYSQL_USER",
    content: "Username for MySQL database.",
    html: "<div>Username for MySQL database.</div>"
  },
  {
    key: "RDBMS_MYSQL_PASS",
    content: "Password for MySQL database.",
    html: "<div>Password for MySQL database.</div>"
  },
  {
    key: "RDBMS_MYSQL_DB",
    content: "Database name for MySQL connection.",
    html: "<div>Database name for MySQL connection.</div>"
  },
  {
    key: "PG_HOST",
    content: "Hostname for PostgreSQL database.",
    html: "<div>Hostname for PostgreSQL database.</div>"
  },
  {
    key: "PG_PORT",
    content: "Port number for PostgreSQL database.",
    html: "<div>Port number for PostgreSQL database.</div>"
  },
  {
    key: "PG_USER",
    content: "Username for PostgreSQL database.",
    html: "<div>Username for PostgreSQL database.</div>"
  },
  {
    key: "PG_PASS",
    content: "Password for PostgreSQL database.",
    html: "<div>Password for PostgreSQL database.</div>"
  },
  {
    key: "PG_NAME",
    content: "Database name for PostgreSQL connection.",
    html: "<div>Database name for PostgreSQL connection.</div>"
  },
  {
    key: "GOOGLE_DOC_TOKEN",
    content: "Token for Google Docs API access.",
    html: "<div>Token for Google Docs API access.</div>"
  },
  {
    key: "SLACK_KEY",
    content: "API key for Slack integration.",
    html: "<div>API key for Slack integration.</div>"
  },
  {
    key: "DISABLE_ALL_SCREEN_ACCESS",
    content: "Flag to disable access to all screens.",
    html: "<div>Flag to disable access to all screens.</div>"
  }
  // {
  //   key: "COMMUNITY_USERS_LOGIN",
  //   content: "Enables or disables community user login.",
  //   html: "<div>Enables or disables community user login.</div>"
  // },
  // {
  //   key: "COMMUNITY_USERS_SIGNUP",
  //   content: "Enables or disables community user signup.",
  //   html: "<div>Enables or disables community user signup.</div>"
  // }
];

export const getHtmlByKey = (key) => {
  const item = document.find((item) => item.key === key);
  return item ? item.html : null;
};

export const getContentByKey = (key) => {
  const item = document.find((item) => item.key === key);
  return item ? item.content : null;
};

export default document;
